class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    const overlay = this.querySelector(
      '#CartDrawer-Overlay'
    );

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector(
        '#cart-icon-bubble'
      );

    if (!cartLink) return;

    cartLink.setAttribute(
      'role',
      'button'
    );

    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        this.open(cartLink);
      }
    );

    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          event.preventDefault();

          this.open(cartLink);
        }
      }
    );
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(
        triggeredBy
      );
    }

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute(
        'role'
      )
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }

    setTimeout(() => {
      this.classList.add(
        'animate',
        'active'
      );
    });

    this.refreshCartIcon();

    this.addEventListener(
      'transitionend',
      () => {
        /*
         * The custom empty-cart markup (cart_empty_liquid) has no
         * .drawer__inner-empty wrapper; fall back to the dialog so
         * focus still moves in and Escape keeps working.
         */
        const containerToTrapFocusOn =
          this.classList.contains(
            'is-empty'
          )
            ? this.querySelector(
                '.drawer__inner-empty'
              ) ||
              this.querySelector(
                '.drawer__inner'
              )
            : document.getElementById(
                'CartDrawer'
              );

        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );

        trapFocus(
          containerToTrapFocusOn,
          focusElement
        );
      },
      {
        once: true
      }
    );

    document.body.classList.add(
      'overflow-hidden'
    );
  }

  /*
   * Custom add-to-cart code updates the drawer but not the header
   * count, so refresh it whenever the drawer opens. On failure the
   * old count stays.
   */
  refreshCartIcon() {
    const cartIcon =
      document.getElementById(
        'cart-icon-bubble'
      );

    if (!cartIcon) {
      return;
    }

    fetch(
      '/?sections=cart-icon-bubble'
    )
      .then((response) =>
        response.ok
          ? response.json()
          : null
      )
      .then((sections) => {
        const html =
          sections &&
          sections['cart-icon-bubble'];

        if (html) {
          cartIcon.innerHTML =
            this.getSectionInnerHTML(
              html
            );
        }
      })
      .catch(() => {});
  }

  close() {
    this.classList.remove(
      'active'
    );

    removeTrapFocus(
      this.activeElement
    );

    document.body.classList.remove(
      'overflow-hidden'
    );
  }

  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute(
        'id'
      )
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    const drawerInner =
      this.querySelector(
        '.drawer__inner'
      );

    if (
      drawerInner &&
      drawerInner.classList.contains(
        'is-empty'
      )
    ) {
      drawerInner.classList.remove(
        'is-empty'
      );
    }

    this.productId =
      parsedState.id;

    this.getSectionsToRender().forEach(
      (section) => {
        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );

        if (!sectionElement) {
          return;
        }

        const sectionHtml =
          parsedState.sections[
            section.id
          ];

        if (!sectionHtml) {
          return;
        }

        sectionElement.innerHTML =
          this.getSectionInnerHTML(
            sectionHtml,
            section.selector
          );
      }
    );

    setTimeout(() => {
      const overlay =
        this.querySelector(
          '#CartDrawer-Overlay'
        );

      if (overlay) {
        overlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      this.open();
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const parsedHtml =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHtml.querySelector(
        selector
      );

    return element
      ? element.innerHTML
      : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      );
  }

  setActiveElement(element) {
    this.activeElement =
      element;
  }
}

customElements.define(
  'cart-drawer',
  CartDrawer
);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);